import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  buildReservationSchemas,
  ReservationSchemaMessages,
} from "../guests/utils/reservationSchema";

export function useReservationSchemas() {
  const { t } = useTranslation();

  return useMemo(() => {
    const messages: ReservationSchemaMessages = {
      firstNameRequired: t("reservation.validation.firstNameRequired"),
      lastNameRequired: t("reservation.validation.lastNameRequired"),
      nameFormat: t("reservation.validation.nameFormat"),
      emailRequired: t("reservation.validation.emailRequired"),
      emailInvalid: t("reservation.validation.emailInvalid"),
      phoneRequired: t("reservation.validation.phoneRequired"),
      phoneDigits: t("reservation.validation.phoneDigits"),
      countryRequired: t("reservation.validation.countryRequired"),
      dateOfBirthFuture: t("reservation.validation.dateOfBirthFuture"),
      roomRequired: t("reservation.validation.roomRequired"),
      arrivalDateRequired: t("reservation.validation.arrivalDateRequired"),
      arrivalDatePast: t("reservation.validation.arrivalDatePast"),
      departureDateRequired: t("reservation.validation.departureDateRequired"),
      departureDatePast: t("reservation.validation.departureDatePast"),
      departureAfterArrival: t("reservation.validation.departureAfterArrival"),
      estimatedArrivalRequired: t(
        "reservation.validation.estimatedArrivalRequired",
      ),
      estimatedArrivalPast: t("reservation.validation.estimatedArrivalPast"),
    };
    return buildReservationSchemas(messages);
  }, [t]);
}
